angular
  .module('company')

  .factory('PaymentCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class PaymentCrud extends Crud {
        constructor(list) {
          super(
            'payment' + (list || ''),
            '@@apiUrl' + '/payments' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return PaymentCrud;
    }
  ]);
